import { PlatformType } from 'modules/platform';
import { AppActionInit } from './types';
import { AppAction } from './constants';

export const appActionInit = (platform: PlatformType): AppActionInit => ({
  type: AppAction.INIT,
  platform: platform,
});
